import React from 'react';
import colors from '../../assets/styles/colors';
import { BsCheck } from 'react-icons/bs'
import {
  InputRadioButtonContainer,
  InputRadioButtonField,
  InputRadioButtonLabel
} from './styles';

export const InputRadioButton = ({ onClick, item, checked, value }) => {
  return (
    <InputRadioButtonContainer>
      <InputRadioButtonField id="checkbox" checked={checked} onClick={onClick}>
        <BsCheck color={colors.white} id="check-icon" />
      </InputRadioButtonField>
      <InputRadioButtonLabel>{value}</InputRadioButtonLabel>
    </InputRadioButtonContainer>
  )
}

export default InputRadioButton;
